import { Injectable } from '@angular/core';
import {State, Action, StateContext, Selector} from '@ngxs/store';
import { storeLocationIdAction } from './auth.action';
import { storeLocIdAction, storeNursestationIdAction, storestationIdlocationidAction } from './nursestationids.action';
export class storeStationLocationIdsModel{
     
    locationId: number;
     
    nursingStationIds: string;
 }
 @State<storeStationLocationIdsModel>({
     name: 'stationidlocId',
     defaults: {
        
        locationId:0, 
        nursingStationIds: ''
      }
 })
 @Injectable()
 export class storeNurStationidLocatioIdState {
 
     constructor( ) {
     }
 
     @Selector()
     static getNurStationId(state: storeStationLocationIdsModel) {
         return state;
     }
     @Action(storestationIdlocationidAction)
     storestationIdlocationidAction({getState, patchState}: StateContext<storeStationLocationIdsModel>, {payload}: storestationIdlocationidAction) {

         const state = getState();
         patchState({
              
              locationId:payload.locationId, 
              nursingStationIds: payload.nursingStationIds
         });
     }
     @Action(storeNursestationIdAction)
     storeNursestationIdAction({getState, patchState}: StateContext<storeStationLocationIdsModel>, {payload}: storeNursestationIdAction) {

        const state = getState();
        patchState({
     
            nursingStationIds:payload
        });
    }
    @Action(storeLocIdAction)
    storeLocIdAction({getState, patchState}: StateContext<storeStationLocationIdsModel>, {payload}: storeLocIdAction) {

        const state = getState();
        patchState({
     
            locationId:payload
        });
    }
}